import { Platform } from "react-native";
import { z } from "zod";

// Zod v4's JIT parser compiles object schemas with `new Function`, which the
// web build's `script-src` CSP blocks (surfaced in Sentry as a
// "Blocked 'script' from 'eval:'" violation). Force the interpreter path on
// web so Zod never touches eval.
if (Platform.OS === "web") {
  z.config({ jitless: true });
}
